import React, { useEffect, useRef, useState } from 'react';
import { Paper } from '@mui/material';
import EAPagination from './datatable/EAPagination';
import useStyles from '../../style/js-style/components/common/ListLayoutStyle';
import TitleWithIcon from './TitleWithIcon';
import SkeletonDataGrid from './skeleton/SkeletonDataGrid';

/**
 * Main content wrapper for thirdparties / dossiers / documents list page
 *
 * @param children
 * @param title
 * @param icon
 * @param count
 * @param totalCount
 * @param addingComponent for adding element in right part of header
 */
function ListLayout({
  children,
  title,
  icon,
  count,
  totalCount,
  addingComponent,
  isLoading,
  filterField,
  customFilers = true,
  paginationType = 'PAGINATION',
}) {
  const { classes } = useStyles();
  const [showSkeleton, setShowSkeleton] = useState(false);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [filterHeight, setFilterHeight] = useState(0);
  const filterRef = useRef(null);

  // Delay before displaying the skeleton to avoid a flash effect when no result
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowSkeleton(true);
    }, 200);
    return () => clearTimeout(timeoutId);
  }, []);

  // Ajoute un évènement pour traquer la width de la page
  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // eslint-disable-next-line
  useEffect(() => {
    if (filterRef) {
      setFilterHeight(
        windowHeight - (filterRef?.current?.offsetHeight || 0) - 260
      );
    }
  });

  return (
    <div
      style={{
        minHeight: 'calc(100vh - 190px)',
        backgroundColor: '#f7f8fc',
        padding: '16px 0px',
        maxHeight: filterHeight + 'px',
      }}
    >
      <div className={classes.headerWrapper}>
        <TitleWithIcon
          icon={icon}
          title={title}
          resultCount={count || 0}
          totalCount={totalCount}
          isLoading={isLoading}
          style={{ marginLeft: '18px' }}
        />
        {addingComponent}
      </div>
      {filterField && <div ref={filterRef}>{filterField}</div>}
      <Paper elevation={0} className={classes.dataGridWrapper}>
        {isLoading && showSkeleton ? <SkeletonDataGrid /> : children}
      </Paper>
      <EAPagination
        isLoading={isLoading}
        fromList
        paginationType={paginationType}
      />
    </div>
  );
}

export default ListLayout;
